(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_hotspot"] && !Shopify.designMode) return;
  try {
    (function() {
    function initHotspots() {
      const hotspots = document.querySelectorAll('.banner-hotspot');

      hotspots.forEach(function(hotspot) {
        // Skip if already initialized
        if (hotspot.dataset.initialized === 'true') return;
        hotspot.dataset.initialized = 'true';

        const marker = hotspot.querySelector('.banner-hotspot__marker');
        const tooltip = hotspot.querySelector('.banner-hotspot__tooltip');

        if (!marker || !tooltip) return;

        // Function to position tooltip within viewport
        function positionTooltip() {
          const rect = hotspot.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          const viewportWidth = window.innerWidth;

          // Reset tooltip positioning (tooltip is always flipped below marker)
          tooltip.style.left = '';
          tooltip.style.right = '';
          tooltip.style.transform = '';
          tooltip.classList.remove('tooltip--left', 'tooltip--right');

          // Calculate tooltip horizontal position
          const hotspotCenterX = rect.left + rect.width / 2;
          const tooltipWidth = tooltipRect.width || tooltip.offsetWidth;
          const margin = 10;

          // Check if tooltip would overflow left edge
          if (hotspotCenterX - tooltipWidth / 2 < margin) {
            tooltip.classList.add('tooltip--left');
            tooltip.style.left = margin + 'px';
            tooltip.style.transform = 'translateX(0)';
          }
          // Check if tooltip would overflow right edge
          else if (hotspotCenterX + tooltipWidth / 2 > viewportWidth - margin) {
            tooltip.classList.add('tooltip--right');
            tooltip.style.right = margin + 'px';
            tooltip.style.transform = 'translateX(0)';
          }
          // Center tooltip
          else {
            tooltip.style.left = '50%';
            tooltip.style.transform = 'translateX(-50%)';
          }
        }

        // Show tooltip on hover - attach to both marker and hotspot
        function showTooltip() {
          hotspot.classList.add('active');
          // Position tooltip after it becomes visible
          setTimeout(function() {
            positionTooltip();
          }, 10);
        }

        function hideTooltip() {
          hotspot.classList.remove('active');
        }

        marker.addEventListener('mouseenter', showTooltip);
        marker.addEventListener('mouseleave', hideTooltip);
        hotspot.addEventListener('mouseenter', showTooltip);
        hotspot.addEventListener('mouseleave', hideTooltip);

        // Touch support for mobile - show tooltip on touch
        marker.addEventListener('touchstart', function(e) {
          e.stopPropagation();
          hotspot.classList.toggle('active');
          if (hotspot.classList.contains('active')) {
            setTimeout(function() {
              positionTooltip();
            }, 10);
          }
        });

        // Reposition tooltip on window resize
        window.addEventListener('resize', function() {
          if (hotspot.classList.contains('active')) {
            positionTooltip();
          }
        });

        // If marker is a link, prevent navigation on first click to show tooltip
        if (marker.tagName === 'A') {
          marker.addEventListener('click', function(e) {
            // Allow navigation, but tooltip will show on hover
            // If you want to show tooltip on click first, uncomment below:
            // e.preventDefault();
            // hotspot.classList.toggle('active');
            // setTimeout(function() {
            //   if (hotspot.classList.contains('active')) {
            //     window.location.href = marker.href;
            //   }
            // }, 300);
          });
        }
      });

      // Close tooltips when clicking outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.banner-hotspot')) {
          hotspots.forEach(function(hotspot) {
            hotspot.classList.remove('active');
          });
        }
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHotspots);
    } else {
      initHotspots();
    }

    // Re-initialize when new content is added (for theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initHotspots);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
